import React from "react";
import { Modal, Button, Image } from "react-bootstrap";
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';

const useStyles = createUseStyles({
  deleteModal: {
    '& .modal-content': {
      width: '427px',
      height: '367px',
      margin: '0 auto',
      paddingTop: '40px',
    },
  },
  modalContent: {
    padding: '20px',
  },
  modalCloseBtn: {
    position: 'absolute',
    top: '29px',
    right: '13px',
  },
  deleteImg: {
    width: '180px',
    margin: '0 auto',
    marginBottom: '22px',
  }, deleteBtn: {
    backgroundColor: '#DF3744 !important',
    color: 'white !important',
    borderRadius: '14px',
    fontSize: '13px',
    fontWeight: 'normal',
    border: '0',
    padding: '4px',
    marginLeft: '12px',
    paddingLeft: '12px',
    paddingRight: '12px',
  },
});

const DeleteModal = ({ onDelete, onHide, ...rest }) => {
  const classes = useStyles();

  const themeState = useSelector(state => state.themeState);

  return (
    <Modal
      {...rest}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className={classes.deleteModal}
    >
      <Button
        onClick={onHide}
        variant="none"
        className={classes.modalCloseBtn}
      >
        <Image
          src={themeState.themeMode === 'dark' ? '/assets/images/close-circle-dark.svg' : '/assets/images/close-circle.svg'}
        />
      </Button>
      <Image
        src={themeState.themeMode === 'dark' ? '/assets/images/del-img-dark.png' : '/assets/images/del-img.png'}
        className={classes.deleteImg}
      />

      <p className="font-14 font-weight-medium text-center mb-5 page-heading">
        Are you sure you want to delete this Item?
      </p>

      <div className="d-flex justify-content-center">
        <Button
          variant="none"
          className="font-13 font-weight-medium gradient-border px-3 page-heading"
          onClick={onHide}
        >
          Cancel
        </Button>
        <Button
          variant="none"
          className={classes.deleteBtn}
          onClick={onDelete}
        >
          <Image
            src="/assets/images/delete-outline-white.svg"
            className="delete-icon"
          />
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteModal;
